<template>
  <div>
    <div
      class="search-result-card pointer"
      :class="selected ? 'color_white_bg': null"
      @click="$emit('topicSelected', topic_index)"
    >
      <!-- LEFT BAR -->
      <div class="left-bar">
        <div class="topic-title brand_navy font-weight-bold">{{ topic_title }}</div>
        <div class="topic-details color_grey_dark">{{ topic_term }} • {{ topic_week }}</div>
      </div>

      <!-- RIGHT BAR -->
      <div class="right-bar">
        <div class="avatar brand_inverse_bg" v-if="selected">
          <div class="icon-accept color_white font-13 flex-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchResultCard",

  props: {
    topic_index: Number,
    topic_title: String,
    topic_term: String,
    topic_week: String,
    selected: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.search-result-card {
  @include flex_row_between_nowrap;
  padding: 9px 10px;
  margin-bottom: 4px;
  transition: all 0.3s ease-in-out;

  &:hover {
    background: $color_white;
  }

  .left-bar {
    .topic-title {
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 4px;
    }
    .topic-details {
      font-size: 12px;
      line-height: 16px;
    }
  }

  .right-bar {
    .avatar {
      @include equal_min_edge(18);
    }
  }
}
</style>
